/**
 * EmptyState — literary, bee-mascot-driven empty sections for Profile.
 * Mirrors bookshelf/EmptyState.jsx's shape and copy convention.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { MascotContainer, Button } from '@/components/site/primitives';
import { fadeUp } from '@/lib/motion';
import { EMPTY_STATE_MESSAGES } from './constants';
import { PROFILE } from '@/constants/testIds';

import beeStand from '@/assets/bee-stand.png';
import beeFly from '@/assets/bee-fly.png';
import beeRead from '@/assets/bee-read.png';
import beeScribble from '@/assets/bee-scribble.png';

const MASCOTS = {
  currentlyReading: beeRead,
  favorites: beeRead,
  recentlyRead: beeStand,
  tbr: beeFly,
  scribbles: beeScribble,
  writing: beeScribble,
  communities: beeFly,
};

export default function EmptyState({ type, to, onCTAClick, className = '', compact = false }) {
  const message = EMPTY_STATE_MESSAGES[type] ?? EMPTY_STATE_MESSAGES.tbr;

  const cta = to ? (
    <Button as={Link} to={to} variant="primary" icon={false} className="mt-5">
      {message.cta}
    </Button>
  ) : onCTAClick ? (
    <Button variant="primary" icon={false} onClick={onCTAClick} className="mt-5">
      {message.cta}
    </Button>
  ) : null;

  return (
    <div
      className={`flex items-center justify-center ${compact ? 'min-h-[200px] py-6' : 'min-h-[280px] py-10'} ${className}`}
      data-testid={PROFILE.emptyState}
    >
      <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }} className="mx-auto max-w-sm text-center">
        <MascotContainer src={MASCOTS[type] ?? beeStand} alt="" className={compact ? 'mx-auto h-20 w-20' : 'mx-auto h-24 w-24'} />
        <h3 className="mt-3 font-display text-lg font-semibold text-ink">{message.heading}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-subtle">{message.subheading}</p>
        {cta}
      </motion.div>
    </div>
  );
}
